<style lang="sass" scoped>
.add-btn
  display: flex
  justify-content: center
.field-area
  display: inline-flex
  align-items: center
  width: 100%
  margin: auto
  .field
    width: 300px
</style>

<template lang="pug">
div.data-section
  div.space-btw
    h3 PROMOTORES
    v-btn(icon @click='addPromoterDialog = true')
      v-icon mdi-plus
  div.my-2
    div(v-for='(promoter, i) in promoters' :key='i')
      div.pa-4 {{promoter.email}}
      v-divider(v-if='i < promoters.length - 1')
  v-dialog(v-model='addPromoterDialog' max-width='500px')
    v-card
      v-card-title
        | Adicionar promotor
        v-spacer
        v-btn(icon @click='addPromoterDialog = false')
          v-icon mdi-close
      v-card-text
        v-form(ref='form')
          v-text-field.field(v-model='email' label='E-mail do promotor')
      v-card-actions
        v-btn(@click='$refs.form.reset()' :disabled='addingPromoter') Limpar
        v-spacer
        v-btn(@click='add()' :loading='addingPromoter') Salvar
  v-snackbar(v-model='snackbar')
    div Convite enviado ao promotor! {{invite_link}}
    v-btn(icon @click='snackbar = false')
      v-icon mdi-close
</template>

<script>
import utils from '../../utils/requests'

export default {
  props: {
    id: String
  },
  data () {
    return {
      email: '',
      invite_link: null,
      promoters: [],
      addPromoterDialog: false,
      addingPromoter: false,
      snackbar: false
    }
  },
  mounted () {
    utils.postAPI('/event/retrieve_event_promoters', { 'id': this.id }).then(res => {
      console.log('promoters: ', res)
      this.promoters = res.promoters
      console.log(this.promoters)
    })
  },
  methods: {
    add () {
      this.addingPromoter = true
      const data = {
        'event_id': this.id,
        'email': this.email
      }

      utils.postAPI('/event/add_user_as_promoter', data).then(res => {
        console.log(res)
        this.email = ''
        this.invite_link = res.link
        this.addingPromoter = false
        this.addPromoterDialog = false
        this.snackbar = true
      })
    }
  }
}
</script>
